import React from 'react';
import styled from 'styled-components';
import { theme } from '@kvdbil/components';
import ContentLoader from 'react-content-loader';
import { useTranslation } from '~/Locale';

const ContentLoaderCardWrapper = styled.div`
  border: ${({ theme }) => `1px solid ${theme.colors.grayscaleToned.light4}`};
  border-radius: 0.25rem;
  margin: auto;
  display: flex;
  width: 100%;

  svg {
    height: 374px;
    width: 100%;
  }
`;

const AuctionLoadingCard = () => {
  const { t } = useTranslation();
  return (
    <ContentLoaderCardWrapper
      data-testid="product-card-loader"
      role="status"
      aria-busy="true"
      aria-label={t('Loading product card')}
    >
      <ContentLoader
        animate={false}
        height={374}
        width={244}
        backgroundColor={theme.colors.grayscaleToned.light4}
        foregroundColor={theme.colors.grayscaleToned.light5}
        title=""
        role="presentation"
      >
        <rect x="0" y="0" rx="3" ry="3" width="100%" height="164" />
        <rect x="10" y="180" rx="3" ry="3" width="160" height="12" />
        <rect x="10" y="200" rx="3" ry="3" width="100" height="12" />
        <rect x="10" y="240" rx="0" ry="0" width="100%" height="1" />
        <rect x="10" y="300" rx="3" ry="3" width="82" height="12" />
        <rect x="140" y="300" rx="3" ry="3" width="82" height="12" />
      </ContentLoader>
    </ContentLoaderCardWrapper>
  );
};

export default AuctionLoadingCard;
